export default __webpack_public_path__ + "static/joyful-71601d573fe1777e591c0443d4feaa73.png";